import { IQueryContext } from 'framework/context/IQueryContext';
import { IQueryResult, IStockEntriesQueryParams, IStockEntryDto } from 'gen/ApiClient';
import React from 'react';

export const QueryContext = React.createContext<IQueryContext<IQueryResult<IStockEntryDto>, IStockEntriesQueryParams>>(undefined as any);
